import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  actionTo?: string;
  actionLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionTo,
  actionLabel,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-7">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-700 uppercase tracking-wider mb-2">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{title}</h2>
        {desc && <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">{desc}</p>}
      </div>
      {actionTo && actionLabel && (
        <Link
          to={actionTo}
          className="shrink-0 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
        </Link>
      )}
    </div>
  );
}